import React from 'react';
import { classes } from '@bloomberg/media-ui-core';

import { BaseAd } from '../BaseAd/index';
import { GlobalAdProps } from '../types/index';

import styles from './InBodyAds.module.css';

export const InBodyAds = React.forwardRef<HTMLDivElement, GlobalAdProps>(
  function InBodyAdsComponent(
    { className, name = 'InBodyAd', ...props }: GlobalAdProps,
    ref
  ) {
    return (
      <BaseAd
        ref={ref}
        className={classes(styles.inBodyAd, { className })}
        name={name}
        adType="in-body"
        {...props}
      />
    );
  }
);
